export { default as TelegramIcon } from '~icons/akar-icons/telegram-fill';
